<script setup>
</script>
<template>
  <div class="page-container holiday-page timings-page">
    <section class="annoucements_banner_archive">
      <div class="home-container">
        <div class="announcements_banner_content">
          <div class="announcements-title">
            <p>Stock Market Timings</p>
          </div>
          <div class="banner-img">
            <img
              src="https://upstox.com/app/themes/upstox/dist/img/market-data/holiday-banner.png>"
              alt="banner"
            />
          </div>
        </div>
      </div>
    </section>
    <section class="breadcrumbs-sec">
      <div class="container breadcrumbs-ol">
        <div class="stocks-indices-breadcrumbs_wrap">
          <ol class="stocks-indices-breadcrumbs">
            <li>
              <a href="/">
                <span>Trading </span>
              </a>
            </li>
            <li>
              <a
                href="/stocks-market/share-market-holiday-list/"
              >
                <span>Stock Market </span>
              </a>
            </li>
            <li>
              <span>Share Market Timing </span>
            </li>
          </ol>
        </div>
      </div>
    </section>

    <!--tools description-->
    <section class="holidays">
      <div class="container home-container">
        <div class="a-article-wrapper holidays-wrapper">
          <div class="main-heading">
            <h1>Stock Market Timings in India</h1>
            <p>
              Here’s your comprehensive guide to the stock market timings in
              India. By knowing these timings and utilising the sessions,
              traders and market participants can navigate the stock market with
              confidence and optimise their investment strategies.
            </p>
            <p>&nbsp;</p>
            <p>
              The stock market operates year-round from Monday to Friday, except
              on advance declared trading holidays. Weekends which include
              Saturdays and Sunday, are closed for trading
            </p>
            <h2>
              NSE and BSE Trading Schedule:<img
                loading="lazy"
                class="alignnone wp-image-42597"
                src="https://upstox.com/app/uploads/2023/05/stock-market-timings-1.png"
                alt=""
                width="1228"
                height="269"
                srcset="
                  https://upstox.com/app/uploads/2023/05/stock-market-timings-1.png          1161w,
                  https://upstox.com/app/uploads/2023/05/stock-market-timings-1-300x66.png    300w,
                  https://upstox.com/app/uploads/2023/05/stock-market-timings-1-1024x225.png 1024w,
                  https://upstox.com/app/uploads/2023/05/stock-market-timings-1-768x169.png   768w,
                  https://upstox.com/app/uploads/2023/05/stock-market-timings-1-50x11.png      50w
                "
                sizes="(max-width: 1228px) 100vw, 1228px"
              />
            </h2>
          </div>
          <div class="main-heading">
            <div class="table-responsive">
              <table style="height: 57px" width="681">
                <tbody>
                  <tr>
                    <td>
                      <ul>
                        <li>Pre-Open Session</li>
                      </ul>
                    </td>
                    <td>
                      <ul>
                        <li>9:00 AM to 9:15 AM</li>
                      </ul>
                    </td>
                    <td>
                      <ul>
                        <li>
                          An important window of time that lets investors to
                          place orders before the regular trading hours.
                        </li>
                      </ul>
                      <p>&nbsp;</p>
                      <ul>
                        <li>
                          This session is helpful for market participants to
                          determine their trading strategies by
                        </li>
                      </ul>
                      <p>1: Analysing overnight developments</p>
                      <p>2: Tuning into official announcements</p>
                      <p>3: Observing the global cues</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <ul>
                        <li>Continuous Session</li>
                      </ul>
                    </td>
                    <td>
                      <ul>
                        <li>9:15 AM to 3:30 PM</li>
                      </ul>
                    </td>
                    <td>
                      <ul>
                        <li>
                          The continuous session, also known as market hours, is
                          the main session when the majority of trading takes
                          place. During this time, investors, traders and market
                          participants can buy or sell stocks, bonds, and other
                          financial instruments listed on the exchanges.
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <ul>
                        <li>Closing Session</li>
                      </ul>
                    </td>
                    <td>
                      <ul>
                        <li>3:30 PM to 3:40 PM</li>
                      </ul>
                    </td>
                    <td>
                      <ul>
                        <li>Marks the end of the regular trading session.</li>
                      </ul>
                      <p>&nbsp;</p>
                      <ul>
                        <li>Marks the initiation of the closing session.</li>
                      </ul>
                      <p>&nbsp;</p>
                      <ul>
                        <li>The closing price of securities is determined.</li>
                      </ul>
                      <p>&nbsp;</p>
                      <ul>
                        <li>
                          1: The closing price of a security is calculated by
                          using a weighted average of prices at securities
                          trading from 3:00 PM to 3:30 PM on a stock exchange.
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <ul>
                        <li>Post-Close Session</li>
                      </ul>
                    </td>
                    <td>
                      <ul>
                        <li>3:40 PM to 4:00 PM</li>
                      </ul>
                    </td>
                    <td>
                      <ul>
                        <li>
                          This period is after the stock market closing time.
                        </li>
                      </ul>
                      <p>&nbsp;</p>
                      <ul>
                        <li>Bids for the next day’s trade can be placed.</li>
                      </ul>
                      <p>&nbsp;</p>
                      <ul>
                        <li>
                          The bids placed at this time are confirmed, given that
                          adequate buyers and sellers are present in the market.
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p>&nbsp;</p>
            <p>
              *It’s advised to be updated on the official announcements made by
              the stock exchanges to know about any changes to the schedule.
            </p>
            <h2>Commodity Trading Timings</h2>
            <p>
              Commodity trading is elemental to India’s economy. Investors,
              traders and other market participants can trade in various
              commodities like gold, silver, crude oil, agricultural products,
              and more. Three primary commodity exchanges are currently
              operational in India:
            </p>
            <ul>
              <li>The Multi Commodity Exchange (MCX)</li>
              <li>The National Commodity and Derivatives Exchange (NCDEX)</li>
              <li>The Indian Commodity Exchange (ICEX)</li>
            </ul>
            <p>
              The commodity market operates year-round from Monday to Friday,
              except on advance declared trading holidays.
            </p>
            <h2>MCX Trading Schedule:</h2>
            <p>
              <img
                loading="lazy"
                class="alignnone size-full wp-image-42598"
                src="https://upstox.com/app/uploads/2023/05/share-market-timing-in-india.png"
                alt=""
                width="1161"
                height="334"
                srcset="
                  https://upstox.com/app/uploads/2023/05/share-market-timing-in-india.png          1161w,
                  https://upstox.com/app/uploads/2023/05/share-market-timing-in-india-300x86.png    300w,
                  https://upstox.com/app/uploads/2023/05/share-market-timing-in-india-1024x295.png 1024w,
                  https://upstox.com/app/uploads/2023/05/share-market-timing-in-india-768x221.png   768w,
                  https://upstox.com/app/uploads/2023/05/share-market-timing-in-india-50x14.png      50w
                "
                sizes="(max-width: 1161px) 100vw, 1161px"
              />
            </p>
            <p>&nbsp;</p>
            <div class="table-responsive">
              <table style="height: 57px" width="681">
                <tbody>
                  <tr>
                    <td>
                      <ul>
                        <li>Special Session</li>
                      </ul>
                    </td>
                    <td>
                      <ul>
                        <li>8:45 AM to 8:59 AM</li>
                      </ul>
                    </td>
                    <td>
                      <ul>
                        <li>
                          The Special Session, also known as the order
                          cancellation session, is held to cancel the pending
                          orders (if the trader or investor requires) prior to
                          opening of market.
                        </li>
                      </ul>
                      <p>&nbsp;</p>
                      <ul>
                        <li>
                          It is important to note that no actual trades take
                          place.
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <ul>
                        <li>Continuous Session</li>
                      </ul>
                    </td>
                    <td>
                      <ul>
                        <li>9:15 AM to 3:30 PM</li>
                      </ul>
                    </td>
                    <td>
                      <ul>
                        <li>
                          The continuous session, also known as market hours, is
                          the main session when the majority of trading takes
                          place. During this time, investors, traders and market
                          participants can buy or sell stocks, bonds, and other
                          financial instruments listed on the exchanges.
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <ul>
                        <li>Normal Session</li>
                      </ul>
                    </td>
                    <td>
                      <ul>
                        <li>9:00 AM to 11:30 PM</li>
                      </ul>
                    </td>
                    <td>Trade orders can be placed.</td>
                  </tr>
                  <tr>
                    <td>
                      <ul>
                        <li>Post Market Session</li>
                      </ul>
                    </td>
                    <td>
                      <ul>
                        <li>11:30 PM to 11:55 PM</li>
                      </ul>
                    </td>
                    <td>
                      <ul>
                        <li>
                          Investors can place orders for the next trading day.
                        </li>
                      </ul>
                      <p>&nbsp;</p>
                      <ul>
                        <li>
                          It is important to note that post-market orders placed
                          during this session will be executed only when the
                          regular trading session begins the next day.
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <ul>
                        <li>Extended Trading Hours</li>
                      </ul>
                    </td>
                    <td>
                      <ul>
                        <li>11:30 PM to 11:55 PM</li>
                      </ul>
                    </td>
                    <td>
                      <ul>
                        <li>
                          Indian commodity exchanges have introduced extended
                          trading hours to facilitate trading for various
                          participants.
                        </li>
                      </ul>
                      <p>&nbsp;</p>
                      <ul>
                        <li style="list-style-type: none">
                          <ul>
                            <li>
                              The extended trading hours provide additional
                              flexibility to align with the global commodity
                              markets.
                            </li>
                          </ul>
                        </li>
                      </ul>
                      <p>&nbsp;</p>
                      <ul>
                        <li>
                          Please also note that extended trading hours may
                          differ based on the commodity and the exchange.
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p>&nbsp;</p>
            <p>
              *It’s advised to be updated on the official announcements made by
              the stock exchanges to know about any changes to the schedule.
            </p>
            <p>&nbsp;</p>
            <p>
              The MCX has revised its trading hours on Monday, 13th March 2023,
              and onwards. This is to keep under consideration the change in the
              US daylight saving time.
            </p>
            <p>&nbsp;</p>
            <p>The revised trading hours for the MCX are:</p>
            <p>&nbsp;</p>
            <div class="table-responsive">
              <table style="height: 57px" width="681">
                <tbody>
                  <tr class="pre-header">
                    <th>Particulars</th>
                    <th>Trade Start Time</th>
                    <th>Trade End Time</th>
                    <th>Client Code Modification Session</th>
                  </tr>
                  <tr>
                    <td>Non-Agri Commodities</td>
                    <td>9:00 AM</td>
                    <td>11:30 PM</td>
                    <td>11:30 PM to 11:45 PM</td>
                  </tr>
                  <tr>
                    <td>Select Agri Commodities (Cotton, CPO &amp; Kapas)</td>
                    <td>9:00 AM</td>
                    <td>9:00 PM</td>
                    <td>9:00 PM to 9:15 PM</td>
                  </tr>
                  <tr>
                    <td>All Other Agri Commodities</td>
                    <td>9:00 AM</td>
                    <td>5:00 PM</td>
                    <td>5:00 PM to 5:15 PM</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p>&nbsp;</p>
            <p>
              *It’s advised to be updated on the official announcements made by
              the stock exchanges to know about any changes to the schedule.
            </p>
            <h2>Muhurat Trading</h2>
            <p>
              Muhurat trading in the year 2023 will take place on Sunday, 12th
              November 2023.
            </p>
            <p>&nbsp;</p>
            <p>
              Muhurat trading occurs when the exchanges open for one hour, on
              the occasion of Diwali.
            </p>
            <p>&nbsp;</p>
            <p>
              The pre-opening session for muhurat trading starts at 6:00 PM and
              lasts for 15 minutes. This is followed by a continuous trading
              session that starts at 6:15 PM and ends at 7:15 PM.
            </p>
            <p>&nbsp;</p>
            <div class="table-responsive">
              <table style="height: 57px" width="681">
                <tbody>
                  <tr class="pre-header">
                    <th>Event</th>
                    <th>Time</th>
                  </tr>
                  <tr>
                    <td>Pre-open session</td>
                    <td>6:00 PM – 6:08 PM IST</td>
                  </tr>
                  <tr>
                    <td>Muhurat Trading</td>
                    <td>6:15 PM – 7:15 PM IST</td>
                  </tr>
                  <tr>
                    <td>Post-close session</td>
                    <td>7:30 PM – 7:38 PM IST</td>
                  </tr>
                  <tr>
                    <td>Market close</td>
                    <td>7:40 PM IST</td>
                  </tr>
                </tbody>
              </table>
              <p>&nbsp;</p>
            </div>
            <p>
              *Please note that the exact timings for Muhurat Trading are
              usually announced by the stock exchanges a few days before Diwali.
              The above timings are just an example and may differ from year to
              year.
            </p>
            <h2>Frequently Asked Questions (FAQs)</h2>
            <h3>What are the stock market timings in India?</h3>
            <p>
              The regular trading hours for the NSE and BSE are from Monday to
              Friday, 9:15 AM to 3:30 PM, Indian Standard Time (IST).
            </p>
            <h3>Are the trading timings the same for the NSE and BSE?</h3>
            <p>
              Yes, the trading timings are the same for both stock exchanges.
            </p>
            <h3>Is trading open 24-hours in India?</h3>
            <p>
              No, there are specified times at which the stock exchanges operate
              in India, year-round.
            </p>
            <h3>
              Are the timings the same for equity, commodity, and currency
              markets?
            </h3>
            <p>No, the timings differ for each market segment.</p>
            <h3>Can I buy shares after 3:30 PM?</h3>
            <p>
              Yes, you can buy shares after 3:30 PM as the closing session, also
              known as the post-market session is open from 3:40 PM to 4:00 PM
              for the NSE and BSE. However, only market orders are permitted.
              Like pre-market orders, post-market orders are only permitted for
              the equity segment. The MCX follows its own trading schedules that
              operates after 3:30 PM.
            </p>
            <h3>Are there any extended trading hours?</h3>
            <p>
              Yes, there are extended trading hours for equity derivatives
              (futures and options). The extended trading session is known as
              the “After Market Order” session.
            </p>
            <h3>Are there any trading holidays?</h3>
            <p>
              Yes, there are trading holidays. The stock exchanges release an
              official list of trading holidays for each calendar year.
            </p>
            <h3>Can I trade on Saturdays and Sundays?</h3>
            <p>
              No, the Indian stock market is closed on Saturdays and Sundays.
            </p>
            <h3>Can anyone participate in Muhurat Trading?</h3>
            <p>
              Yes, anyone who has a trading account with a registered
              stockbroker can participate in Muhurat Trading.
            </p>
            <h3>Is Muhurat Trading different from regular trading?</h3>
            <p>
              No, Muhurat Trading is not different from regular trading. Its
              special feature is that it is conducted on a special day and for a
              shorter duration.
            </p>
            <h3>Is it necessary to participate in Muhurat Trading?</h3>
            <p>
              No, it is not necessary to participate in Muhurat Trading. It is a
              choice by the investor.
            </p>
            <p>
              *Please note that the Indian Stock Market trading schedule may
              change from year to year and it is always recommended to check for
              the most up-to-date information from reliable sources before
              making any trading decisions or planning your investment
              activities. Always consult with a financial advisor for
              personalised investment advice.
            </p>
            <p>Happy investing!</p>
          </div>
        </div>
        <!-- end of holidays-wrapper -->
      </div>
      <!-- end of container -->
      <!-- end of calculator-container-inner -->
    </section>
  </div>
</template>
<style scoped>
</style>
<style lang="scss" src="@/styles/css/stock-market-holiday.scss">
</style>
<style lang="scss" src="@/styles/css/seo-calculators.scss">
</style>
